export default __webpack_public_path__ + "static/media/FancyNovel.01f6ad9e.png";